<div *ngIf="list?.length" class="responsive-containers responsive-values cursor -text-align-centre -category-list">
  <mat-card *ngFor="let item of list;" (click)="onCardClick(item)">
    <mat-card-content>
      <div>
        <img [src]="item?.imageUrl + token" class="img-fluid img-200-px" />
      </div>
      <h4>{{ item?.title }}</h4>
      <div>
        {{ item?.variants?.length }}
        <ng-container *ngIf="item?.variants?.length === 1; else multipleVariant">Variant</ng-container>
        <ng-template #multipleVariant>Variants</ng-template>
      </div>
    </mat-card-content>
  </mat-card>
</div>